export const ROUTER_QUERY_STRING = {
  PLAYER_TYPE: "playerType",
};

export const PLAYER_TYPE = {
  SINGLE_STEP_PLAYER: "singleStepPlayer",
};
